import React from "react";

import ContentLoader from 'react-content-loader';

function LoadingUser() {
  let width = 100;

  return (<>
    <ContentLoader
      width={150}
      height={50}
      backgroundColor="#323F4B"
      foregroundColor="#2f3a45"
      className="mh-5"
    >
      <rect x="3" y="12" rx="3" ry="3" width="88" height="6" />
      <rect x="39" y="28" rx="3" ry="3" width="52" height="6" />
      <circle cx="114" cy="22" r="20" />
    </ContentLoader>
  </>);
}

export default LoadingUser;